/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowADownRightIcon24Regular = forwardRef('ArrowADownRightIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M19.125 17.888 5.119 3.88A.875.875 0 1 0 3.88 5.12l14.007 14.006H7.5a.875.875 0 0 0 0 1.75H18A2.875 2.875 0 0 0 20.875 18V7.5a.875.875 0 0 0-1.75 0v10.388Z" })));
});
